<template>
  <section class="commercial-prices-form">
    <commercial-form
      :loading="loading"
      :sections="sections"
      :selected-store="selectedStore"
      :rule="vehiclePrices.read.item"
      remove-action="vehiclePrices/delete"
      @submit="submit"
      @removed="removed"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import monetize from '@sdk/helpers/formatters/monetize';

  import former from '@/helpers/mixins/former';
  import scrollHelper from '@/helpers/views/scroll';

  import { pricesSections } from '@/views/Settings/Commercial/Form/sections';

  import commercialMap, {
    storesMap,
    pricesMap,
  } from '@/views/Settings/Commercial/Form/maps';

  import CommercialForm from '@/views/Settings/Commercial/Form.vue';

  export default {
    name: 'CommercialPricesForm',
    components: {
      CommercialForm,
    },
    mixins: [former],
    data() {
      return {
        // A loja da regra que esta tela abriu, para o seletor conseguir mostrá-la
        // mesmo quando ela está fora da página de lojas que o campo carregou.
        selectedStore: null,
        sections: pricesSections(),
      };
    },
    computed: {
      ...mapState([
        'vehiclePrices',
      ]),
      loading() {
        return this.vehiclePrices.create.loading;
      },
    },
    mounted() {
      this.setFieldCallback(pricesMap.default_price_cents, this.changedDefaultPriceCents);

      this.getVehiclePrice();
    },
    methods: {
      // A LOJA VEM DO CAMINHO - ver o comentário equivalente em `Returns/Form.vue`.
      getVehiclePrice() {
        const {
          id: storeID,
          rule_id: ruleID,
        } = this.$route.params;

        this.setFieldValue(storesMap.store_id, storeID);

        if (!ruleID) {
          // Criando não há tabela - ver o comentário equivalente em `Returns/Form.vue`.
          this.$store.dispatch('vehiclePrices/clear', { action: 'read' });

          return;
        }

        this.setFieldProcessing(storesMap.store_id, true);
        this.setFieldProcessingBulk(commercialMap, true);
        this.setFieldProcessingBulk(pricesMap, true);

        this.$store
          .dispatch('vehiclePrices/read', {
            id: ruleID,
          })
          .then(this.gotVehiclePrice);
      },
      gotVehiclePrice() {
        const {
          store,
          store_id: storeID,
          vehicle_model: vehicleModel,
          default_price_cents: defaultPriceCents,
          min_price_cents: minPriceCents,
        } = this.vehiclePrices.read.item;

        this.selectedStore = store;
        this.setFieldValue(storesMap.store_id, storeID);
        this.setFieldValue(commercialMap.vehicle_model_id, vehicleModel.id);
        this.setFieldValue(pricesMap.default_price_cents, defaultPriceCents);
        this.setFieldValue(pricesMap.min_price_cents, minPriceCents);

        this.setFieldProcessingBulk(commercialMap, false);
        this.setFieldProcessingBulk(pricesMap, false);
      },
      changedDefaultPriceCents() {
        const defaultPriceCents = this.getFieldValue(
          pricesMap.default_price_cents,
          { clean: true },
        );

        this.setFieldValidations(pricesMap.min_price_cents, [{
          type: 'blank',
        }, {
          type: 'lessThan',
          equal: true,
          count: defaultPriceCents,
          formatter: monetize,
        }]);
      },
      submit() {
        const payload = {
          store_id: this.getFieldValue(storesMap.store_id),
          vehicle_model_id: this.getFieldValue(
            commercialMap.vehicle_model_id,
          ),
          default_price_cents: this.getFieldValue(pricesMap.default_price_cents, { integer: true }),
          min_price_cents: this.getFieldValue(pricesMap.min_price_cents, { integer: true }),
        };

        this.$store
          .dispatch('vehiclePrices/create', payload)
          .then(this.submitSuccess)
          .catch(this.submitFailure);
      },
      // De volta à listagem da loja em que a tabela ficou - ver `Returns/Form.vue`.
      submitSuccess() {
        this.$router.push({
          name: 'stores-commercial-control-prices',
          params: {
            id: this.getFieldValue(storesMap.store_id),
          },
        });
      },
      // A tabela removida: a loja é a dela - ver `Returns/Form.vue`.
      removed(storeID) {
        this.$router.push({
          name: 'stores-commercial-control-prices',
          params: {
            id: storeID,
          },
        });
      },
      submitFailure() {
        const {
          error,
        } = this.vehiclePrices[this.$route.params.rule_id ? 'update' : 'create'];

        this.setErrors({
          ...commercialMap,
          ...pricesMap,
        }, error);

        scrollHelper();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
